function generatePlanFilter<T extends CorePlan>({
  plan,
  policies,
  period
}: {
  plan: T
  policies: number
  period: number
}): PlanFilter {
  return {
    coinsurance: plan.coreBenefits.userCoinsurance,
    coverage: plan.coreBenefits.lifetimeMax,
    deductible: plan.coreBenefits.deductible,
    moop: plan.coreBenefits.outOfPocketMax,
    policies: policies,
    period: period
  }
}

export default generatePlanFilter
